export default [
    {
        path: '/sales/task',
        name: 'task',
        props: true,
        component: () => import('@/views/sales/task/index.vue'),
        meta: {
            pageTitle: 'Task',
            breadcrumb: [
                {
                text: 'Task',
                active: true,
                },
            ],
        },
    },
    {
        path: '/sales/task/add',
        name: 'create-task',
        component: () => import('@/views/sales/task/create.vue'),
        meta: {
            pageTitle: 'Create Task',
            breadcrumb: [
                {
                text: 'Task',
                to: { name: 'task' },
                },
                {
                text: 'Create Task',
                active: true,
                },
            ],
        },
    },
    {
        path: '/sales/task/:id',
        name: 'detail-task',
        props: true,
        component: () => import('@/views/sales/task/detail.vue'),
        meta: {
            pageTitle: 'Detail Task',
            breadcrumb: [
                {
                text: 'Task',
                to: { name: 'task' },
                },
                {
                text: 'Detail Task',
                active: true,
                },
            ],
        },
    },
]